import React, { useContext } from 'react';
import { signOut } from '@app/auth/firebase';
import { useLocation } from '@app/utils';
import {
  BackgroundContainer,
  Container,
  Actions,
  HeaderLogo,
} from './login-header-components';
import { Link } from '@app/components';
import { AuthContext } from '@app/providers';
import { useAddOrRemoveToken } from '@app/graphql';
type props = {
  location?: string;
};

export default function LoginHeader({ location }: props) {
  const { location: route, navigate } = useLocation();
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const [removeToken] = useAddOrRemoveToken();

  const Logout = async () => {
    const token: string = localStorage.getItem('token') || '';
    const params = {
      token: token,
      firebaseId: userInfo ? userInfo.id : '',
      expiryDateTime: Date(),
      action: 'REMOVE',
    };
    await removeToken({ variables: params })
      .then((res: any) => {})
      .catch((error: any) => {
        console.log(error);
      });
    signOut();
    setUserInfo(null);
    setTimeout(() => {
      navigate('/');
    }, 500);
  };

  return (
    <BackgroundContainer>
      <Container>
        <Link variant="white" href="/">
          <HeaderLogo />
        </Link>
        {!route.pathname.includes('/process-account') && (
          <Actions>
            {location === 'email-verify' ? (
              <Link variant="white" href="/" onClick={Logout}>
                Sign Out
              </Link>
            ) : (
              <Link
                variant="white"
                href={location === 'sign-in' ? '/sign-up' : '/sign-in'}>
                {location === 'sign-in' ? 'Sign Up' : 'Sign In'}
              </Link>
            )}
          </Actions>
        )}
      </Container>
    </BackgroundContainer>
  );
}
